<template>
  <RbuSectionPaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    data-url="admin/contract/contract_percentage/contract_percentage_year/section/"
    data-key="ContractYearFluctuationSections"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-section-list"
    style="margin-top: 1rem"
  >
    <template #item.need_manual_update="{ value }">
      <v-icon color="red" v-if="value">mdi-exclamation-thick</v-icon>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="editItemFluctuation(item)">
          Fluctuation
        </v-btn>
      </div>
    </template>
  </RbuSectionPaginatedList>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS, USER_TYPE } from "@/constants";
import RbuSectionPaginatedList from "../RbuSectionPaginatedList";

export default {
  name: "ASorSectionList",
  components: { RemotePaginatedList, RbuSectionPaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
    contract: Object,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
      // reset item table / filter
      root.$store.dispatch(ACTION_TYPES.RBU_ITEM_LIST_RESET_ALL);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      // { text: root.$t("rbu.edition"), value: "edition.id", contains: true },
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("rbu_section.order_no"), value: "order_no" },
      { text: "Insufficient Census Data", value: "need_manual_update" },
      { text: "", value: "actions", sortable: false, width: 100 },
    ]);
    const innerRefreshTrigger = ref(false);

    const editItemFluctuation = async function (item) {
      root.$router.push({
        name: "contract-percentage-section-fluctuation",
        params: { contractPercentageSectionId: item.id },
      });
    };

    const canShowAction = function (item) {
      if (!item) return false;
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].includes(
        root.$store.getters.account.type
      );
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItemFluctuation,

      PERMISSIONS,
      canShowAction,
    };
  },
};
</script>

<style lang="less"></style>
